import type { FirebaseApp } from 'firebase/app';
import { useLocation } from 'react-router-dom';

import { readStoredAppLanguage } from '../features/app/language-storage';
import { createTranslator, getInitialAppLanguage } from '../i18n';
import { ConsentBanner } from './consent-banner';
import { useConsent } from './use-consent';

/**
 * Owns the consent decision and renders the banner when — and only when — a
 * decision is still required (EU/UK region, nothing stored yet). On mount,
 * `useConsent` has already started telemetry for the paths that don't need a
 * prompt (non-EU, or previously granted), so this component renders nothing in
 * the common case. Mount it once, inside the router (the banner links to the
 * public `/privacy/` document), alongside the app.
 */
export function ConsentGate({ app }: { app: FirebaseApp | null }) {
  const { shouldPrompt, acceptAll, rejectAll } = useConsent(app);
  const location = useLocation();

  if (!shouldPrompt) {
    return null;
  }

  const appLanguage = getInitialAppLanguage(readStoredAppLanguage());
  const t = createTranslator(appLanguage);

  return (
    <ConsentBanner
      appLanguage={appLanguage}
      compact={location.pathname.startsWith('/trainer/demo')}
      onAccept={acceptAll}
      onReject={rejectAll}
      t={t}
    />
  );
}
